export default {
    install(Vue) {
        const SearchBoosterApi = window['searchbooster'].api;
        Vue.prototype.$configuration = SearchBoosterApi.configuration;
        Vue.prototype.$instances = SearchBoosterApi.instances;
    },
};